import React, { useState, useEffect } from 'react';
import { API_BASE } from '../config/api';
import siteContentStatic from '../data/siteContent.json';

function Partenaires() {
  const [data, setData] = useState(siteContentStatic.partners);

  useEffect(() => {
    fetch(`${API_BASE}/api/site-content`)
      .then(res => { if (!res.ok) throw new Error(); return res.json(); })
      .then(content => { if (content.partners) setData(content.partners); })
      .catch(() => {});
  }, []);

  return (
    <article className="page type-page status-publish hentry">
      <header className="entry-header">
        <h1 className="entry-title">{data.title}</h1>
      </header>

      <div className="entry-content">
        <p style={{ textAlign: 'left' }}>{data.intro}</p>

        <p style={{ textAlign: 'justify' }}>Les principaux d'entre eux sont :</p>

        <ul>
          {data.list.map((partner, i) => (
            <li key={i} style={{ textAlign: 'justify' }}>
              {partner.url ? (
                <a href={partner.url} target="_blank" rel="noopener noreferrer">{partner.name}</a>
              ) : (
                partner.name
              )}
            </li>
          ))}
        </ul>

        <p style={{ textAlign: 'left' }}>{data.funding}</p>

        {data.logos && data.logos.length > 0 && (
          <div className="logos-showcase">
            {data.logos.map((logo, i) => (
              <img
                key={i}
                src={logo.src}
                alt={logo.alt}
                loading="lazy"
              />
            ))}
          </div>
        )}
      </div>
    </article>
  );
}

export default Partenaires;
